import $ from 'jquery';
import { getListId } from '../../react/utils/klavio';
import { urlParams } from '../../react/utils/tools';

function setUpReferral() {
  $(document).on('swell:setup', function () {
    function copyLinkToClipboard() {
      var link = document.querySelector('.swell-referral-link').textContent;
      const el = document.createElement('textarea');
      el.value = link;
      document.body.appendChild(el);
      el.select();
      document.execCommand('copy');
      document.body.removeChild(el);
    }

    function checkUTM(utm_param) {
      return urlParams.get(utm_param) ? urlParams.get(utm_param) : null;
    }

    function submitEmail() {
      let email = $('#logged-out-email').val();
      let source = 'direct';
      let campaign = 'direct';
      let medium = 'direct';
      const listId = getListId();

      if (checkUTM('utm_source')) {
        source = checkUTM('utm_source');
      } else if (window.location.href && window.location.href.includes('account')) {
        source = 'Login Page';
      }

      if (checkUTM('utm_campaign')) {
        campaign = checkUTM('utm_campaign');
      }

      if (checkUTM('utm_medium')) {
        medium = checkUTM('utm_medium');
      }

      var settings = {
        async: true,
        crossDomain: true,
        url: 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe',
        method: 'POST',
        headers: {
          'content-type': 'application/x-www-form-urlencoded',
          'cache-control': 'no-cache',
        },
        data: {
          g: listId,
          $fields: 'Source, Medium, Campaign, customSource',
          email: email,
          Source: source,
          Medium: medium,
          Campaign: campaign,
          customSource: source,
          $source: source,
        },
      };
      $.ajax(settings).done(function (response) {
        window._learnq.push(['identify', { $email: email }]);
      });
    }

    function setupShareAgain() {
      if ($('#share-again-btn')) {
        $('#share-again-btn').on('click', function () {
          $('#enter-email-widget').css('display', 'none');
          $('#thank-you-widget').css('display', 'none');
          $('#share-widget').css('display', 'block');
        });
      }
    }

    function setupNotLoggedEmail() {
      $('#enter-email-widget').css('display', 'block');
      $('#share-widget').css('display', 'none');
      var customersInput = $('#logged-out-email');
      var sendEmailBtn = $('#logged-out-email-share-btn');

      $(sendEmailBtn).click(function () {
        var onSuccess = function () {
          checkEmailSubscription();
          setupEmailSubmit();
        };

        var onError = function () {
          $('#error-popup').css('display', 'flex');
        };

        swellAPI.identifyReferrer(customersInput.val(), onSuccess, onError);
      });
    }

    function checkEmailSubscription() {
      if ($('#checkbox-input') && $('#checkbox-input').is(':checked')) {
        submitEmail();
      }
    }

    function setupEmailSubmit() {
      $('#enter-email-widget').css('display', 'none');
      $('#share-widget').css('display', 'block');
      var referredCustomersInput = $('#email-share-input');
      var sendEmailsBtn = $('#email-share-btn');

      $(sendEmailsBtn).click(function () {
        // assuming you allowed comma separated email input
        var emails = referredCustomersInput.val().split(',');

        var onSuccess = function () {
          $('#share-widget').css('display', 'none');
          $('#thank-you-widget').css('display', 'block');

          setupShareAgain();
        };

        var onError = function (err) {
          var customerDetails = swellAPI.getCustomerDetails();
          var errorDisplayed = false;
          emails.map((email) => {
            if (email === customerDetails.email) {
              $('#error-referred-friend').css('display', 'none');
              $('#error-referred-self').css('display', 'block');
              errorDisplayed = true;
            }
          });
          if (!errorDisplayed) {
            $('#error-referred-self').css('display', 'none');
            $('#error-referred-friend').css('display', 'block');
          }
        };

        swellAPI.sendReferralEmails(emails, onSuccess, onError);
      });

      $('.clickable-link').each(function () {
        $(this).on('click', copyLinkToClipboard);
      });

      var copyLinkWithUTM = $('#swell-referral-link-share-widget').text() + '?c';
      $('#swell-referral-link-share-widget').text(copyLinkWithUTM);

      setupCopyUI();
    }

    function showHideLink(widget) {
      $('#swell-referral-link-' + widget + '-widget').css('display', 'none');
      $('#copied-text-' + widget + '-widget').css('display', 'block');
      setTimeout(function () {
        $('#swell-referral-link-' + widget + '-widget').css('display', 'block');
        $('#copied-text-' + widget + '-widget').css('display', 'none');
      }, 500);
    }

    function setupCopyUI() {
      $('#swell-referral-link-share-widget').on('click', () => showHideLink('share'));
      $('#copy-link-btn').on('click', () => showHideLink('share'));
      $('#swell-referral-link-thankyou-widget').on('click', () => showHideLink('thankyou'));
    }

    if ($('#ftr-list-static')) {
      $('#ftr-list-static').css('display', 'none');
    }

    var customerDetails = swellAPI.getCustomerDetails();

    if (customerDetails.email) {
      //customer exists
      setupEmailSubmit();
      $('#widget-container').css('height', '100%');
    } else {
      setupNotLoggedEmail();
      $('#widget-container').css('height', '100%');
    }
  });
}

export { setUpReferral };
